export class ItemSectionOption {
    public isSelected: boolean = false;

    constructor(
        public resourceKey: string,
    ) { }
}
